import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';
import LinkButton from 'flarum/common/components/LinkButton';
import WikiCategory from './common/models/WikiCategory';
import WikiArticle from './common/models/WikiArticle';
import WikiRevision from './common/models/WikiRevision';
import WikiComment from './common/models/WikiComment';
import WikiReport from './common/models/WikiReport';
import WikiSearchSource from './forum/components/WikiSearchSource';
import extendLinkPreview from './forum/extendLinkPreview';
import { tr } from './forum/utils/translate';
import { basePath, navPriority, navHidden, BASE_PATH } from './forum/utils/helpers';
app.initializers.add('linkrobins-wiki', () => {
  // Register the store models so app.store.find()/createRecord() return typed,
  // cached, relationship-aware records for our resources.
  app.store.models['linkrobins-wiki-categories'] = WikiCategory;
  app.store.models['linkrobins-wiki-reports'] = WikiReport;
  app.store.models['linkrobins-wiki-articles'] = WikiArticle;
  app.store.models['linkrobins-wiki-revisions'] = WikiRevision;
  app.store.models['linkrobins-wiki-comments'] = WikiComment;

  // The wiki pages load on demand, as their own chunks: a visitor reading a
  // discussion never opens them, and parsing them on every page costs phones
  // time. extend.php publishes the chunks with ->jsDirectory(); without it
  // they 404 and every wiki route falls back to the home page.
  app.routes['linkrobins-wiki.index'] = {
    path: BASE_PATH,
    component: () => import(/* webpackChunkName: 'forum/components/WikiIndexPage', webpackMode: 'lazy-once' */ './forum/components/WikiIndexPage')
  };
  app.routes['linkrobins-wiki.compose'] = {
    path: BASE_PATH + '/new',
    component: () => import(/* webpackChunkName: 'forum/components/WikiComposePage', webpackMode: 'lazy-once' */ './forum/components/WikiComposePage')
  };
  app.routes['linkrobins-wiki.show'] = {
    path: BASE_PATH + '/:id',
    component: () => import(/* webpackChunkName: 'forum/components/WikiShowPage', webpackMode: 'lazy-once' */ './forum/components/WikiShowPage')
  };
  app.routes['linkrobins-wiki.edit'] = {
    path: BASE_PATH + '/:id/edit',
    component: () => import(/* webpackChunkName: 'forum/components/WikiComposePage', webpackMode: 'lazy-once' */ './forum/components/WikiComposePage')
  };

  // Wiki articles in the forum's own search dropdown, under their own heading.
  extend(GlobalSearch.prototype, 'sourceItems', items => {
    items.add('linkrobins-wiki', new WikiSearchSource());
  });

  // Global "Wiki" link in the index sidebar nav (shown on every page). The
  // admin picks the position; the default (-11) slots it directly below
  // flarum/tags' "Tags" link (-10) and above its separator (-12) + tag list
  // (-14), so it doesn't sit oddly between "All Discussions" and the tags
  // block. Without the tags extension it simply lands under the remaining nav
  // links. Read at render time, when app.forum exists.
  extend(IndexSidebar.prototype, 'navItems', items => {
    // "Hidden" means never added, so it is absent from the mobile drawer too,
    // which renders this same list.
    if (navHidden()) return;
    items.add('linkrobins-wiki', m(LinkButton, {
      href: basePath() + BASE_PATH,
      icon: 'fas fa-book'
    }, tr('nav', 'Wiki')), navPriority());
  });
  if ('datlechin-link-preview' in flarum.extensions) {
    extendLinkPreview();
  }
});flarum.reg.addChunkModule('873', '491', 'linkrobins-wiki', 'forum/components/WikiIndexPage');
flarum.reg.addChunkModule('873', '491', 'linkrobins-wiki', 'forum/components/WikiIndexSidebar');
flarum.reg.addChunkModule('873', '491', 'linkrobins-wiki', 'forum/utils/api');
flarum.reg.addChunkModule('873', '491', 'linkrobins-wiki', 'forum/utils/permissions');
flarum.reg.addChunkModule('873', '491', 'linkrobins-wiki', 'forum/utils/indexLayout');
flarum.reg.addChunkModule('553', '279', 'linkrobins-wiki', 'forum/components/WikiComposePage');
flarum.reg.addChunkModule('553', '279', 'linkrobins-wiki', 'forum/utils/composer');
flarum.reg.addChunkModule('290', '187', 'linkrobins-wiki', 'forum/components/WikiShowPage');
flarum.reg.addChunkModule('290', '187', 'linkrobins-wiki', 'forum/components/WikiReportModal');
flarum.reg.addChunkModule('290', '187', 'linkrobins-wiki', 'forum/components/WikiComments');
flarum.reg.addChunkModule('290', '187', 'linkrobins-wiki', 'forum/utils/diff');
flarum.reg.addChunkModule('290', '187', 'linkrobins-wiki', 'forum/utils/toc');